var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from 'app/core/api/api.js';
import { deleteDataFomCollection } from './utils';
import upload from 'app/core/utils/upload';
const removeDuplicates = (data, key) => {
    return [...new Map(data.map((x) => [key(x), x])).values()];
};
const initialState = {
    data: [],
    loading: false,
    count: 0,
};
export const createMedias = createAsyncThunk('reduxMedias/create', (files_1, _a) => __awaiter(void 0, [files_1, _a], void 0, function* (files, { fulfillWithValue, rejectWithValue }) {
    try {
        const uploadRes = yield upload({ files });
        return fulfillWithValue(uploadRes);
    }
    catch (error) {
        return rejectWithValue(error);
    }
}));
export const deleteMedias = createAsyncThunk('reduxMedias/delete', (ids_1, _a) => __awaiter(void 0, [ids_1, _a], void 0, function* (ids, { fulfillWithValue, rejectWithValue }) {
    try {
        const mediasIds = ids.map((id) => ({ id }));
        yield api.medias.collection.delete(mediasIds);
        return fulfillWithValue(ids);
    }
    catch (error) {
        return rejectWithValue(error);
    }
}));
const { actions, reducer } = createSlice({
    name: 'reduxMedias',
    initialState,
    reducers: {
        setAllMedias: (state, { payload }) => {
            const t = [...state.data, ...payload];
            const newData = removeDuplicates(t, (it) => it.id);
            state.data = newData;
        },
        addMediaFromWS: (state, { payload }) => {
            const updatedPayload = Object.assign(Object.assign({}, payload), { id: payload.uuid });
            delete updatedPayload.uuid;
            const t = [...state.data, updatedPayload];
            const newData = removeDuplicates(t, (it) => it.id);
            state.data = newData;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(deleteMedias.fulfilled, (state, { payload }) => {
            const newData = deleteDataFomCollection(state.data, payload);
            state.data = newData;
        });
        builder.addCase(createMedias.fulfilled, (state, { payload }) => {
            const newData = [...state.data, ...payload];
            state.data = newData;
        });
    },
});
export const { setAllMedias, addMediaFromWS } = actions;
export default reducer;
